<template>
  <div>
    <template v-if="!checkEmail">
      <h1 class="text-sm-center mt-4 mb-2">Forgot Password</h1>
      <p class="text-sm-center mb-4">
        It happens to all of us. Please enter your email address.
      </p>

      <v-alert
        type="error"
        class="mt-4 mb-2"
        dismissible
        :value="error"
        @input="error = arguments[0] ? error : null"
      >
        {{ error }}
      </v-alert>

      <v-form class="form-box">
        <v-text-field
          ref="email"
          type="email"
          v-model="email"
          v-validate="'required|email'"
          data-vv-name="email"
          :error-messages="errors.collect('email')"
          label="Email"
          outline
          required
        />

        <v-btn
          type="submit"
          color="primary"
          large
          block
          :loading="submitting"
          @click.prevent="submit"
        >
          Submit
        </v-btn>

        <p class="mt-5">
          <router-link :to="{ name: 'login' }">Login</router-link>
        </p>
      </v-form>
    </template>
    <template v-else>
      <div class="text-sm-center">
        <p>
          We have sent {{ email }} an email with reset instructions.
        </p>
        <p class="mt-5">
          <router-link :to="{ name: 'login' }">Return to Login</router-link>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import api from '../api';

export default {
  data: () => ({
    error: null,

    email: '',
    submitting: false,
    checkEmail: false,
  }),

  methods: {
    async submit() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }

      this.submitting = true;
      this.error = null;

      const { email } = this;

      api.endpoints.auth
        .requestPasswordReset({ email }, { handleErrors: false })
        .then(() => {
          this.checkEmail = true;
        })
        .catch(error => {
          this.error = 'Error. Please try again.';

          if (error.response && error.response.data && error.response.data.detail) {
            this.error = error.response.data.detail;
          }
        })
        .then(() => {
          this.submitting = false;
        });
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.email) {
        this.$refs.email.focus();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  padding: 16px;
  text-align: center;
}
</style>
